module.exports = __webpack_public_path__ + "img/intro-bg.64bbb194.svg";